import { TdsButton, TdsField } from '@trv-tds/react'
import type { WrappedFieldInputProps } from 'redux-form'
import { Field, reduxForm } from 'redux-form'

import { maxSize,required, valid, validator } from '../lib/validators'
import {
  ButtonContainer,
  Card,
  CardHeader,
  PageInformation
} from '../shared/styledComponents'
import type { IdentityFormType } from './types'


const normalize50 = (value: string) => value && value.replace(/[^a-zA-Z0-9 &.`-]/g, '').slice(0, 50)
const normalizeEmail = (value: string) => value && value.replace(/[<>/{}]/g, '')

const IdentityInput = ({ input, label }: { input: WrappedFieldInputProps; label: string }) => (
  <TdsField label={label} style={{ width: '50%' }}>
    <input {...input} name={label} />
  </TdsField>
)

type IdentityFormProps = {
  handleSubmit(event: React.SyntheticEvent): void
  invalid?: boolean
  openWarningModal(): void
}

const IdentityFormComponent = ({
  handleSubmit,
  invalid,
  openWarningModal
}: IdentityFormProps) => (
  <form noValidate>
    <Card>
      <CardHeader>Contact Details</CardHeader>
      <PageInformation id='identity-text'>
        We may need to get in touch with you. Tell us a bit more about yourself.
      </PageInformation>
      <Field
        id='identityName'
        name='identityName'
        label='Your Name or Business'
        autoFocus={true} // eslint-disable-line jsx-a11y/no-autofocus
        type='text'
        role='textbox'
        required={true}
        normalize={normalize50}
        component={IdentityInput}
      />
      <div style={{ height: '18px' }} />
      <Field
        id='identityEmail'
        name='identityEmail'
        label='Email'
        type='email'
        autoCapitalize='off'
        autoCorrect='off'
        autoComplete='email'
        required={true}
        normalize={normalizeEmail}
        component={IdentityInput}
      />
    </Card>
    <ButtonContainer>
      <TdsButton
        id='identityContinueButton'
        variant='primary'
        onClick={handleSubmit}
        disabled={invalid}
        buttonType='submit'
        style={{ marginRight: '1rem' }}
      >
        Continue
      </TdsButton>
      <TdsButton
        id='identityBackButton'
        variant='secondary'
        onClick={() => openWarningModal()}
      >
        Back
      </TdsButton>
    </ButtonContainer>
  </form >
)

const validEmailMsg = 'Please enter a valid email address.'

const validEmailCheck =
  // eslint-disable-next-line max-len
  valid(/^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  validEmailMsg
)

const notEmptyWithValidEmailInput = validator(required(validEmailMsg), validEmailCheck)
const notEmptyWithValidNameInput = validator(
  required('Please enter a valid name or business.'),
  maxSize(50, 'Must be 50 characters or less.')
)
const validate = (values: IdentityFormType) => ({
  identityName: notEmptyWithValidNameInput(values.identityName),
  identityEmail: notEmptyWithValidEmailInput(values.identityEmail)
})

const IdentityForm = reduxForm<IdentityFormType, IdentityFormProps>({
  form: 'identityForm',
  validate,
  destroyOnUnmount: false,
  touchOnChange: true,
  touchOnBlur: true
})(IdentityFormComponent)

export {
  IdentityForm
}
